<template>
  <div class="phone-container">
    <div class="phone-frame">
      <div class="screen">
        <!-- Header -->
        <div class="header">
          <div class="back-button">
            <VIcon class="backIcon" name="arrow-left-line"></VIcon>
          </div>
          <div class="headerTitle" :title="user.referallshopName">{{ user.referallshopName }}</div>
          <div class="actions">
            <VIcon name="check-circle-line"></VIcon>
            <VIcon name="more-vertical-line"></VIcon>
          </div>
        </div>
        
        <!-- Message area -->
        <div class="message-area">

          <!-- Text -->
          <div v-if="contentType === 'text' || contentType === 'reply'">
            <div  class="message-bubble">
            <div class="avatar">
              <VIcon name="profile-line" :size="-5"></VIcon>
            </div>
            <div class="message-content text-content">
              <p v-html="formattedText(messageText)"></p>
            </div>
          </div>
            <div v-if="contentType == 'reply'" class="button-container">
              <div v-for="(suggestionChips, index) in quickreplyButtons" :key="index">
                <div class="pill-button">
                  <VIcon v-if="suggestionChips.type !== undefined" :name="getIconForButton(suggestionChips)" class="paddingRight10P"></VIcon>
                  {{ getChipLabel(suggestionChips)  }}
                </div>
              </div>
            </div>
          </div>
          <!-- Image -->
          <div v-if="contentType === 'image'" class="message-bubble">
            <div class="avatar">
              <VIcon name="profile-line" class="img"></VIcon>
            </div>
            <div class="message-content">
              <div v-if="isDynamicURL(mediaSource.payload)" class="dynamic-url-placeholder-preview custom_border_radius">
                <img src="@/resources/images/dynamic_url.svg" class="dynamic-placeholder-icon-preview" alt="dynamic_url"/>
              </div>
              <img v-else-if="mediaSource.payload && finalUrlType == 'static'" :src="mediaSource.payload" alt="static_payload" />
              <div v-else>
                 <img src="@/resources/images/image_placeholder.svg" class="dynamic-placeholder-icon-preview" alt="dynamic_url"/>
              </div>
            </div>
          </div>
          <!-- Video -->
          <div v-if="contentType === 'video'" class="message-bubble">
            <div class="avatar">
              <VIcon name="profile-line" class="video"></VIcon>
            </div>
            <div class="message-content">
              <div v-if="isDynamicURL(mediaSource.payload)" class="dynamic-url-placeholder-preview custom_border_radius">
                <img src="@/resources/images/dynamic_url.svg" class="dynamic-placeholder-icon-preview" alt="dynamic_url"/>
              </div>
              <video v-else-if="mediaSource.payload && isBrowserPlayableVideoUrl(mediaSource.payload)" controls>
                <source :src="mediaSource.payload" :type="getVideoMimeType(mediaSource.payload)" />
              </video>
              <div v-else-if="mediaSource.payload" class="videoFallback">
                <VideoFallback :url="mediaSource.payload" />
              </div>
              <div v-else>
                 <img src="@/resources/images/video_placeholder.svg" class="dynamic-placeholder-icon-preview" alt="dynamic_url"/>
              </div>
            </div>
          </div>
          <!-- Document -->
          <div v-if="contentType === 'document'" class="message-bubble">
            <div v-if="isDynamicURL(mediaSource.payload)" class="file-container">
              <div class="dynamic-url-placeholder-preview custom_border_radius" style="min-height: 60px;">
                <img src="@/resources/images/dynamic_url.svg" class="dynamic-placeholder-icon-preview" alt="dynamic_url"/>
              </div>
            </div>
            <div v-else-if="finalUrlType == 'static'" class="file-container cursorPointer flex-between gap10P" @click="openLink(mediaSource.payload)">
              <img src="@/resources/images/document_outline.svg" class="document-img" alt="document">
              <p class="sub-title ion-no-margin overflow-text">{{getFileName(mediaSource) }}</p>
            </div>
          </div>
          <!-- Carousel andf rich card  -->
          <div v-if="contentType === 'carousel' || contentType === 'richcard'">
            <!-- multiple carousels or single rich card -->
            <div v-if="(contentType == 'carousel' || (contentType == 'richcard' && carouselMessage[0]?.template.elements[0]?.extrainfo?.card_orientation == 'VERTICAL'))" class="ion-no-padding carousel-flex">
              <div class="singleCarouselCard"  v-for="(carousel, index) in carouselMessage[0]?.template?.elements" :key="index">
                <div class="container">
                  <div class="carousel-img-block cursorPointer" :class="['carousel-img-block', mediaHeightClass, getCarouselHeightClass(carousel.extrainfo?.height)]">
                    <!-- Show placeholder for dynamic URLs -->
                    <div v-if="carousel.imageurl && isDynamicURL(carousel.imageurl)" class="dynamic-url-placeholder-preview">
                      <VIcon name="carousel?.extrainfo?.media_type.toLowerCase() === 'image' ? image-line : video-line" class="dynamic-placeholder-icon-preview"></VIcon>
                      <p class="dynamic-url-label-preview">Dynamic {{ carousel?.extrainfo?.media_type.toLowerCase() === 'image' ? 'Image' : 'Video' }} will be displayed here</p>
                    </div>
                    <!-- Show actual media for static URLs -->
                    <template v-else>
                      <div v-if="carousel?.extrainfo?.media_type.toLowerCase() == 'image'">
                        <img v-if="carousel.imageurl" :src="carousel.imageurl" width="200" class="carouselImage" alt="carousel" />
                        <img v-else height="50" src="@/resources/images/film_preview.svg" alt="preview"/>
                      </div>
                      <div v-else>
                        <template v-if="carousel.imageurl">
                          <video v-if="isBrowserPlayableVideoUrl(carousel.imageurl)" :src="carousel.imageurl" width="200" controls preload="metadata" class="carouselImage"></video>
                          <div v-else class="videoFallback">
                            <VideoFallback :url="carousel.imageurl" width="100%" height="100%" borderRadius="0px" />
                          </div>
                        </template>
                        <img v-else height="50" src="@/resources/images/film_preview.svg" alt="preview"/>
                      </div>
                    </template>
                  </div>
                  <div class="carousel-title">
                    <p class="ion-no-margin title paddingBottom overflow-text maxwidth100P" v-html="formattedText(carousel.title)"></p>
                    <p class="ion-no-margin sub-title overflow-text maxwidth100P" v-html="formattedText(carousel.subtitle)"></p>
                  </div>
                  <div class="carousel--bttn">
                    <div v-for="button in carousel.buttons" :key="button.payload" class="btn--forWhatsapp">
                      <VIcon v-if="button.action !== undefined || button.type !== undefined" :name="getIconForButton(button)" class="carousel-btn-icon"></VIcon>
                      <span>{{ button.title }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- horizontal rich card with left or right media alignment -->
            <div v-else-if="(contentType == 'richcard' && carouselMessage[0]?.template.elements[0]?.extrainfo?.card_orientation == 'HORIZONTAL')">
              <div  class="card-container" v-for="(carousel, index) in carouselMessage[0]?.template?.elements" :key="index" :class="carouselMessage[0]?.template.elements[0]?.extrainfo?.thumbnail_alignment === 'RIGHT' ? 'rightAlignment' : ''">
                <div class="image-section">
                  <!-- Show placeholder for dynamic URLs -->
                  <div v-if="carousel.imageurl && isDynamicURL(carousel.imageurl)" class="dynamic-url-placeholder-preview horizontal">
                    <VIcon name="carousel?.extrainfo?.media_type === 'IMAGE' ? image-line : video-line" class="dynamic-placeholder-icon-preview-sm"></VIcon>
                  </div>
                  <!-- Show actual media for static URLs -->
                  <template v-else>
                    <div v-if="carousel?.extrainfo?.media_type == 'IMAGE'">
                      <img v-if="carousel.imageurl" :src="carousel.imageurl" width="200" class="carouselImage h-100" alt="carousel" />
                      <img v-else height="50" src="@/resources/images/film_preview.svg" alt="preview"/>
                    </div>
                    <div v-else>
                      <template v-if="carousel.imageurl">
                        <video v-if="isBrowserPlayableVideoUrl(carousel.imageurl)" :src="carousel.imageurl" width="200" controls preload="metadata" class="richCardcarouselImage"></video>
                        <div v-else class="videoFallback">
                          <VideoFallback :url="carousel.imageurl" width="100%" height="100%" />
                        </div>
                      </template>
                      <img v-else height="50" src="@/resources/images/film_preview.svg" alt="preview"/>
                    </div>
                  </template>
                </div>
                <div class="content-section">
                  <div class="title_container">
                    <div class="title overflow-text">
                      <p v-html="formattedText(carousel.title)"></p>
                    </div>
                    <div class="description overflow-text">
                      <p v-html="formattedText(carousel.subtitle)"></p>
                    </div>
                  </div>
                  <div class="richcard--bttn">
                    <div v-for="button in carousel.buttons" :key="button.payload" class="buttons-section">
                      <span>{{ button.title }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Suggestion replies and Actions -->
            <div class="button-container">
              <div v-for="(suggestionChips, index) in carouselMessage[0]?.template?.buttons" :key="index">
                <div class="pill-button">
                  <VIcon v-if="suggestionChips.type !== undefined" :name="getIconForButton(suggestionChips)" class="paddingRight10P"></VIcon>
                  {{ getChipLabel(suggestionChips)  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Input area -->
        <div class="input-area">
          <VIcon name="add-line" class="primaryBlack"></VIcon>
          <VIcon name="image-line" class="primaryBlack"></VIcon>
          <div class="message-input">
            <input type="text" readonly placeholder="RCS message" />
          </div>
          <VIcon name="call-line" class="primaryBlack"></VIcon>
          <VIcon name="emoji-line" class="primaryBlack"></VIcon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { getIcon } from '@/helpers/icon.helper';
import { getVideoMimeType, isBrowserPlayableVideoUrl } from '@/helpers/video.helpers';
import { useAuthStore } from '@/stores/auth';
import VideoFallback from '@/components/VideoFallback.vue';

export default defineComponent({
  mixins: [],
  name: 'rcsPreview',
  components: {
    VideoFallback
  },
  data() {
    return {
      shieldCheckmark: 'check-circle-line',
      documentOutline: 'clear-file-line',
    }
  },
  watch: {
    'mediaSource.payload': {
      handler(newValue) {
        if (this.contentType === 'video' && newValue) {
          // Force video to reload when source changes
          this.$nextTick(() => {
            const videoElement = this.$el.querySelector('video');
            if (videoElement) {
              videoElement.load();
            }
          });
        }
      },
      immediate: true
    }
  },
  computed: {
    user() { return useAuthStore().cleanUserData; },
    mediaHeightClass() {
      return {
        SHORT: 'img-block-short',
        MEDIUM: 'img-block-medium', // Default
        TALL: 'img-block-tall'
      }[this.carouselMessage[0]?.template.elements[0]?.extrainfo?.height] || 'img-block-medium';
    }
	},
  props: {
    contentType: {
      type: String,
      default: 'text'
    },
    messageText: {
      type: String,
      default: 'Message Text'
    },
    mediaSource: {
      type: Object,
      default: () => ({})
    },
    carouselMessage: {
      type: Array,
      default: () => { return []; }
    },
    quickreplyButtons: {
      type: Array,
      default: () => { return []; }
    },
    finalUrlType: {
      type: String,
      default: 'static'
    }
  },
  methods: {
    openLink(payload) {
      if (payload) {
        window.open(payload, '_blank');
      }
    },
    getIconForButton(button) {
      const complianceTypeMap = {
        'compliance_opt_in': 'opt_in',
        'compliance_opt_out': 'opt_out'
      };
      
      const type = complianceTypeMap[button.payload];
      return type ? getIcon({ ...button, type }) : getIcon(button);
    },
    getChipLabel(chip) {
      return chip.text || chip.title || '';
    },
    getFileName(mediaSource) {
      if (mediaSource?.fileName) return mediaSource.fileName;
      // Extract file name from URL
      try {
        const url = mediaSource?.payload || '';
        return url.substring(url.lastIndexOf('/') + 1) || 'File.pdf';
      } catch {
        return 'File.pdf';
      }
    },
    getCarouselHeightClass(height) {
      return {
        SHORT: 'carousel-height-short',
        MEDIUM: 'carousel-height-medium',
        TALL: 'carousel-height-tall'
      }[height] || 'carousel-height-medium'; // Default to medium
    },
    isDynamicURL(url) {
      if (!url) return false;
      // Check for <variable> or {{variable}} patterns
      return /<[^>]+>/.test(url) || /\{\{[^}]+\}\}/.test(url);
    },
    getVideoMimeType,
    isBrowserPlayableVideoUrl,
    formattedText(text) {
      // First handle dynamic variables
      let formattedText = text.replace(/<([^>]+)>/g, (match, p1) => {
        return `<span class="dynamic-variable-span">&lt;${p1}&gt;</span>`;
      });
      
      // Then convert line breaks to <br> tags for proper display
      formattedText = formattedText.replace(/\n/g, '<br>');
      
      return formattedText;
    },
  }
});
</script>

<style scoped>
.carousel-btn-icon {
  margin-right: 5px;
}
.phone-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.phone-frame {
  position: relative;
  width: 375px;
  height: 650px;
  overflow: hidden;
}

.screen {
  height: 88%;
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid var(--black);
  border-radius: 5px;
}

.header {
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #eee;
  height: 60px;
}

.back-button {
  margin-right: 10px;
  padding-top: 5px;
}
.backIcon{
  width: 20px;
  height: 20px;
}

.headerTitle {
  flex-grow: 1;
  font-size: 18px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.actions {
  display: flex;
  gap: 15px;
  font-size: 24px;
}
.message-area {
  flex-grow: 1;
  padding: 15px;
  overflow-y: auto;
  background-color: var(--white);
  border-top: 1px solid var(--black);
}

.message-bubble {
  display: flex;
  margin-bottom: 20px;
  max-width: 100%;
}

.avatar {
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
  top: 22px;
}

.text-content{
  background-color: var(--background-primary);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  line-height: 1.4;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  overflow-y: auto; 
  scrollbar-width: thin; 
  scrollbar-color: transparent transparent;
}
.message-content {
  padding: 12px;
  border-radius: 5px;
  max-width: 100%; 
  max-height: 350px; 
  white-space: pre-line;
}

.message-content::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

.message-content::-webkit-scrollbar-track {
  background: transparent;
}

.message-content::-webkit-scrollbar-thumb {
  background: transparent;
}

.message-content img,
.message-content video {
  max-width: 100%;
  border-radius: 10px;
}

.input-area {
  display: flex;
  align-items: center;
  padding: 15px;
  gap: 10px;
  height: 60px;
}

.message-input {
  flex-grow: 1;
  background-color: #f5f5f5;
  border-radius: 20px;
  padding: 8px 15px;
}

.message-input input {
  width: 100%;
  border: none;
  outline: none;
  background-color: transparent;
}
.antenna {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 56px;
  height: 5px;
  background-color: white;
  border: 1px solid var(--black);
  border-radius: 15px;
  z-index: 10;
}
.image-container{
  width: 150px;
  height: 150px;
}
.avatar .video {
  top: 90px;
  position: relative;
}
.avatar .img {
  top: 98px;
  position: relative;
}
.singleCarouselCard::-webkit-scrollbar {
  display: none;
}
.singleCarouselCard .container{
  min-width: 250px;
  max-width: 300px;
  background: var(--white );
  border: 1px solid #54575E;
  border-radius: 5px;
}
.carousel-title{
	border-bottom: 1px solid #54575E;
  padding: 10px;
  font-size: 14px;
  font-weight: 400;
  color: var(--black);
}
.singleCarouselCard .carousel--bttn{
  border-radius: 0px 0px 5px 5px;
}
.singleCarouselCard .btn--forWhatsapp{
  font-size: 14px;
  color: var(--black);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0px;
  border-bottom: 1px solid #54575E;
  margin-bottom: -1px;
}
.singleCarouselCard .btn--forWhatsapp:last-child{
  border-bottom: none;
}
.carouselImage{
	border-radius: 5px 5px 0px 0px;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.carousel-img-block{
  background: #D9DCE3;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px 5px 0px 0px;
  height: 168px;
  overflow: hidden;
}
.carousel-img-block > div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-block-short {
  height: 112px !important;
}
.img-block-medium {
  height: 168px !important;
}
.img-block-tall {
  height: 264px !important;
}
.carousel-height-short,
.carousel-height-short img.carouselImage {
  height: 100px !important;
}
.carousel-height-medium,
.carousel-height-medium img.carouselImage {
  height: 150px !important;
}
.carousel-height-tall,
.carousel-height-tall img.carouselImage {
  height: 200px !important;
}
.card-container {
  display: flex;
  border: 1px solid #54575E;
  border-radius: 5px;
  overflow: hidden;
  max-width: 600px;
  min-height: 200px;
}
.image-section {
  flex: 1;
  background-color: #D9DCE3;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.content-section {
  flex: 2;
  display: flex;
  flex-direction: column;
}
.title_container{
  padding: 10px;
  flex: 1;
}
.title {
  font-weight: bold;
  font-size: 16px;
  color: var(--black);
}
.description {
  margin-top: 8px;
  font-size: 14px;
  color: var(--black);
}
.overflow-text {
  max-width: 180px;
  max-height: 150px;
  overflow-y: auto;
  word-wrap: break-word;
}
.buttons-section {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--background-primary);
  margin-bottom: -1px;
}
.rightAlignment{
  flex-direction: row-reverse;
}
.file-container{
  border: 1px solid var(--gray-04);
  padding: 10px;
  border-radius: 5px;
}
.document-img {
  width: 40px;
  height: 40px;
}
.maxwidth100P{
  max-width: 100%;
}
.richCardcarouselImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}
.button-container {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 1rem;
}
.pill-button {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border: 1px solid #878A91;
  border-radius: 999px;
  background-color: white;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}
.carousel-flex{
  display: flex;
  align-items: center;
  gap: 15px;
}
.dynamic-variable-span {
  background: var(--purple);
  color: var(--white) !important;
  user-select: none;
  border-radius: 10px;
  display: inline-block;
  padding: 0px 5px;
  cursor: pointer;
}
.dynamic-url-placeholder-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.1) 0%, rgba(229, 229, 229, 0.3) 100%);
  padding: 10px;
  &.horizontal {
    padding: 5px;
  }
}
.dynamic-placeholder-icon-preview {
  font-size: 36px;
  color: var(--purple);
  margin-bottom: 8px;
}
.dynamic-placeholder-icon-preview-sm {
  font-size: 24px;
  color: var(--purple);
  margin-bottom: 4px;
}
.dynamic-url-text-preview {
  font-size: 11px;
  font-weight: 600;
  color: var(--purple);
  text-align: center;
  word-break: break-word;
  margin: 5px 0;
  font-family: monospace;
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 4px;
  max-width: 90%;
}
.dynamic-url-text-preview-sm {
  font-size: 10px;
  font-weight: 500;
  color: var(--purple);
  text-align: center;
  word-break: break-word;
  margin: 3px 0;
  font-family: monospace;
  background: rgba(255, 255, 255, 0.9);
  padding: 3px 6px;
  border-radius: 3px;
}
.dynamic-url-label-preview {
  font-size: 10px;
  color: var(--gray-05);
  text-align: center;
  margin: 0;
  font-style: italic;
}
.custom_border_radius{
  border-radius: 5px;
}
.videoFallback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  border-radius: 8px;
  text-align: center;
  width: 100%;
  height: 100%;
}
.videoFallbackLink {
  color: var(--purple) !important;
  text-decoration: underline;
  font-size: 13px;
}
</style>